import styles from "./InputArea.module.scss";

export default function InputArea({ input }: { input: string[] }) {
  return (
    <>
      <div className={styles.inputArea}>
        {input.map((value, i) => {
          if (value === "") {
            return (
              <h1 key={i} className={styles.underscore}>
                _
              </h1>
            );
          } else {
            return <h1 key={i}>{value}</h1>;
          }
        })}
      </div>
    </>
  );
}
